export const SET_ATTENDACE_LIST = 'SET_ATTENDACE_LIST';
export const SET_ATTENDANCE_STATISTICS = 'SET_ATTENDANCE_STATISTICS';
export const SET_ATTENDANCE_DATES = 'SET_ATTENDANCE_DATES';
export const RESET_ATTENDANCE_DATES = 'RESET_ATTENDANCE_DATES';
export const SET_ATTENDANCE_CHECK_IN = 'SET_ATTENDANCE_CHECK_IN';
export const RESET_ATTENDANCE_CHECK_IN = 'RESET_ATTENDANCE_CHECK_IN';
export const SET_ATTENDANCE_CHECK_OUT = 'SET_ATTENDANCE_CHECK_OUT';
export const RESET_ATTENDANCE_CHECK_OUT = 'RESET_ATTENDANCE_CHECK_OUT';


// WEBPACK FOOTER //
// ./src/store/modules/attendance/mutations.js